import type { Strings } from '../index.ts';
import { unreadable } from './shared.ts';

/**
 * `/hashtag/TAG` — eine Videoliste mit Pager, ausdrücklich keine Suche.
 *
 * Der leere Satz ist der gemessene: dieser Endpunkt antwortet auf ein unbenutztes und ein erschöpftes
 * Tag gleich, die Seite kann also nur aus der angefragten Seitenzahl sagen, was wahrscheinlicher ist,
 * und genau das sagt sie.
 */
export const hashtag: Strings['hashtag'] = {
  loading: (tag) => `#${tag} wird geladen…`,
  label: (tag) => `#${tag}`,

  allDropped: {
    title: 'Dieses Hashtag konnte nicht gelesen werden',
    detail: 'Die Instanz hat geantwortet, und nichts darin ließ sich anzeigen.',
  },

  empty: {
    lastPageTitle: 'Das war die letzte Seite',
    lastPageDetail: 'Für dieses Tag kommt nichts mehr.',
    noneTitle: (tag) => `Nichts mit #${tag}`,
    noneDetail:
      'Entweder hat niemand dieses Hashtag benutzt, oder YouTube wollte es nicht liefern. Von hier aus sieht beides gleich aus.',
  },

  problem: {
    notFound: {
      title: 'Diese Instanz hat keine Hashtag-Seiten',
      detail: 'Sie werden hier nicht angeboten. Manche Instanzen lassen Teile der App weg.',
      retryable: false,
    },
    unreadableTitle: (tag) => `#${tag} konnte nicht gelesen werden`,
    unreadable: unreadable(''),
  },

  paging: {
    backToPage: (page) => `Zurück zu Seite ${page}`,
    loadMore: (soFar) => `Mehr laden (bisher ${soFar})`,
    loadingMore: 'Wird geladen…',
    allLoaded: (count) => `Das sind alle ${count} Videos unter diesem Tag.`,
  },
};
